/**
 * What this account calls the Mitigation page, for the use it is put to:
 * "Loss Prevention" for an insurer, "Service Log" for a service company...,
 * or "Mitigation" until an admin names it (Settings › Display › Mitigation
 * page name). The API puts the enterprise owner's setting on every login
 * (window.currentUser.mitigation_label), so team logins read it too. The
 * menu, the page, its report and the links back to it take the name; the
 * count it keeps is still "mitigated".
 */

// the names the setting offers, with who each suits; an admin may also type their own
export const MITIGATION_LABEL_PRESETS = [
  { name: 'Mitigation', fits: 'The general name' },
  { name: 'Loss Prevention', fits: 'Insurers and risk managers' },
  { name: 'Service Log', fits: 'HVAC and service companies' },
  { name: 'Excursion Log', fits: 'Cold chain, pharmacy and food safety' },
  { name: 'Incident Log', fits: 'Property managers and rentals' },
  { name: 'Response Log', fits: 'Monitoring and operations teams' },
];

export const mitigationLabel = () => {
  const user = window.currentUser || {};
  const label = typeof user.mitigation_label === 'string' ? user.mitigation_label.trim() : '';

  return label || 'Mitigation';
};

export default mitigationLabel;
